import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo1 from "../../assets/images/RuhunaLogo.png";
import logo2 from "../../assets/images/engineeringLogo.png";
import logo3 from "../../assets/images/t_Final logo_light_h.png";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="bg-Color-White bg-opacity-75 backdrop-blur-md sticky top-0 right-0 left-0 z-40 shadow-sm px-4 sm:px-8 lg:px-numbers-48 py-numbers-8">
      <div className="flex justify-between items-center">
        {/* Left: Logos + Text */}
        <Link to="/" className="flex items-center space-x-2 sm:space-x-3 hover:opacity-80 transition-opacity">
          <img src={logo1} alt="University Logo" className="h-8 sm:h-10" />
          <img src={logo2} alt="Engineering Logo" className="h-8 sm:h-10" />
          <img src="footerLogo.png" alt="25 Years Logo" className="h-8 sm:h-10" />
        </Link>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="lg:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1"
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-neutral-600 transition-transform duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-neutral-600 transition-opacity duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-neutral-600 transition-transform duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
        </button>

        {/* Desktop Navigation Links */}
        <div className="hidden lg:flex text-sm font-medium text-neutral-600">

          <Link
            to="/"
            className={`p-[12px] transition relative group hover:font-semibold ${location.pathname === '/' ? 'font-semibold text-Color-Brand' : ''}`}
    >
            Home
            <span className="absolute bottom-2 left-3 right-3 h-[1px] bg-Color-Brand transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left"></span>

          </Link>
          <Link
            to="/events"
            className={`p-[12px] transition relative group hover:font-semibold ${location.pathname === '/events' ? 'font-semibold text-Color-Brand' : ''}`}

          >
            Events
            <span className="absolute bottom-2 left-3 right-3 h-[1px] bg-Color-Brand transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left"></span>
          </Link>
          <Link
            to="/contact-us"
            className={`p-[12px] transition relative group hover:font-semibold ${location.pathname === '/contact-us' ? 'font-semibold text-Color-Brand' : ''}`}
          >
            Contact Us
            <span className="absolute bottom-2 left-3 right-3 h-[1px] bg-Color-Brand transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left"></span>
          </Link>
          <Link
            to="/silver-members"
            className={`px-4 pt-2.5 pb- h-10x transition-all duration-500 relative group hover:font-semibold rounded-md border-[1px] overflow-hidden ${location.pathname === '/silver-members' ? 'font-semibold border-gray-400 shadow-sm' : 'border-gray-300'}`}
          >
            <span className="absolute inset-0 bg-gradient-to-br from-gray-300 via-gray-100 to-gray-300 opacity-40 group-hover:opacity-70 transition-opacity duration-500 bg-[length:200%_200%] animate-silver-shimmer"></span>
            
            {/* Sparkle elements */}
            <span className="absolute top-1 left-1/4 w-1 h-1 bg-white rounded-full opacity-0 animate-sparkle-1"></span>
            <span className="absolute top-1/3 right-1/4 w-1.5 h-1.5 bg-white rounded-full opacity-0 animate-sparkle-2"></span>
            <span className="absolute bottom-1 left-1/3 w-1 h-1 bg-white rounded-full opacity-0 animate-sparkle-3"></span>
            <span className="absolute top-1/2 right-1/3 w-1 h-1 bg-white rounded-full opacity-0 animate-sparkle-4"></span>
            
            <span className="relative z-10 text-gray-800">Silver Members</span>
            <style jsx>{`
              @keyframes silver-shimmer {
                0% {
                  background-position: 0% 0%;
                }
                50% {
                  background-position: 100% 100%;
                }
                100% {
                  background-position: 0% 0%;
                }
              }
              .animate-silver-shimmer {
                animation: silver-shimmer 3s ease-in-out infinite;
              }
              
              @keyframes sparkle {
                0%, 100% {
                  opacity: 0;
                  transform: scale(0);
                }
                50% {
                  opacity: 1;
                  transform: scale(1);
                }
              }
              
              .animate-sparkle-1 {
                animation: sparkle 2s ease-in-out infinite;
                animation-delay: 0s;
              }
              .animate-sparkle-2 {
                animation: sparkle 2s ease-in-out infinite;
                animation-delay: 0.5s;
              }
              .animate-sparkle-3 {
                animation: sparkle 2s ease-in-out infinite;
                animation-delay: 1s;
              }
              .animate-sparkle-4 {
                animation: sparkle 2s ease-in-out infinite;
                animation-delay: 1.5s;
              }
            `}</style>
          </Link>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`lg:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
        <div className="pt-4 pb-2 flex flex-col text-sm font-medium text-neutral-600">

          <Link
            to="/"
            className={`p-[12px] transition relative group hover:font-semibold ${location.pathname === '/' ? 'font-semibold text-Color-Brand' : ''}`}

            onClick={() => setIsMenuOpen(false)}
          >
            Home
            <span className="absolute bottom-2 left-3 right-3 h-[1px] bg-Color-Brand transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left"></span>

          </Link>

          <Link 
            to="/events" 
            className={`p-[12px] transition relative group hover:font-semibold ${location.pathname === '/events' ? 'font-semibold text-Color-Brand' : ''}`}

            onClick={() => setIsMenuOpen(false)}
          >
            Events
            <span className="absolute bottom-2 left-3 right-3 h-[1px] bg-Color-Brand transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left"></span>
          </Link>
          <Link 
            to="/silver-members" 
            className={`px-4 py-2 transition-all duration-500 relative group hover:font-semibold rounded-full border-2 overflow-hidden ${location.pathname === '/silver-members' ? 'font-semibold border-gray-400 shadow-md' : 'border-gray-300'}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <span className="absolute inset-0 bg-gradient-to-br from-gray-300 via-gray-100 to-gray-300 opacity-40 group-hover:opacity-70 transition-opacity duration-500 bg-[length:200%_200%] animate-silver-shimmer"></span>
            
            {/* Sparkle elements */}
            <span className="absolute top-1 left-1/4 w-1 h-1 bg-white rounded-full opacity-0 animate-sparkle-1"></span>
            <span className="absolute top-1/3 right-1/4 w-1.5 h-1.5 bg-white rounded-full opacity-0 animate-sparkle-2"></span>
            <span className="absolute bottom-1 left-1/3 w-1 h-1 bg-white rounded-full opacity-0 animate-sparkle-3"></span>
            <span className="absolute top-1/2 right-1/3 w-1 h-1 bg-white rounded-full opacity-0 animate-sparkle-4"></span>
            
            <span className="relative z-10 text-gray-800">Silver Members</span>
          </Link>
          <Link 
            to="/contact-us" 
            className={`p-[12px] transition relative group hover:font-semibold ${location.pathname === '/contact-us' ? 'font-semibold text-Color-Brand' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact Us
            <span className="absolute bottom-2 left-3 right-3 h-[1px] bg-Color-Brand transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out origin-left"></span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavBar;